import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const AboutPageWrapper = styled.section`
  margin: 20px 0 100px;
`;

const AboutPage = () => (
  <AboutPageWrapper>
    <div className="page-header">
      <h2>About</h2>
    </div>
    <div>
      <p>This site is used as a way to keep track of our favorite songs.</p>

      <p>
        As the days go by, you can follow the progression of each Chimney and use their tracks as recommendations for yourself. By adding
        comments to the <Link to="/message-board">Message Board,</Link> you can let them know what you liked or disliked about their track
        of the day. We want to hear from you.
      </p>

      <p>
        Still confused? Check out our <Link to="/sitemap">site map</Link>.
      </p>
    </div>
    <div>
      <h3>Promotion</h3>
      <ul>
        <li>
          If you would like to send promotional CDs or LPs or 12" singles for possible review on our site, please contact us on{" "}
          <a href="https://soundcloud.com/the-dream-chimney" target="_blank" rel="noopener noreferrer">
            SoundCloud
          </a>{" "}
          for our mailing address. We'll make sure it gets in the proper hands/ears.
        </li>

        <li>
          If you would like to advertise on our site with classic banner ads, please contact us on{" "}
          <a href="https://soundcloud.com/the-dream-chimney" target="_blank" rel="noopener noreferrer">
            SoundCloud
          </a>
        </li>
      </ul>
    </div>
    <div>
      <h3>Follow Us</h3>
      <p>
        As each track is added, it's automatically posted to our{" "}
        <a href="https://twitter.com/dreamchimney" target="_blank" rel="noopener noreferrer">
          twitter
        </a>
        ,{" "}
        <a href="http://facebook.com/dreamchimney/" target="_blank" rel="noopener noreferrer">
          facebook page
        </a>{" "}
        and{" "}
        <a href="http://feeds.feedburner.com/DreamChimneyTrackoftheDay" target="_blank" rel="noopener noreferrer">
          RSS
        </a>
        .
      </p>
    </div>
  </AboutPageWrapper>
);

export default AboutPage;
